import CustomElement from '../core/custom.js'

function leftPad(n, len) {
  return new Array(len - String(n).length + 1).join('0').concat(n)
}

const pad = (n) => leftPad(n, 2)

export default window.customElements.define(
  'time-clock',
  class extends CustomElement {
    short = false
    increment = 1000

    constructor() {
      super()
    }

    connectedCallback() {
      super.connectedCallback()
      this.short = this.dataset.short == 'true'
      this.increment = this.short ? 10000 : 1000

      this.interval = setInterval(this.update.bind(this), this.increment)
      this.date = new Date()
      this.timestamp = Number(this.dataset.timestamp)
      this.date.setTime(this.timestamp)
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      this.interval && clearInterval(this.interval)
    }

    update() {
      this.timestamp += this.increment
      this.date.setTime(this.timestamp)
      this.textContent = this.dateFormatted
    }

    get dateFormatted() {
      const d = this.date
      if (this.short) {
        return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`
      } else {
        return `${pad(d.getUTCHours())} : ${pad(d.getUTCMinutes())} : ${pad(
          d.getUTCSeconds()
        )}   ${d.getUTCHours() >= 12 ? 'PM' : 'AM'}   GMT`
      }
    }
  }
)
